import React, {useEffect, useState} from "react";
import {useSelector} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: theme.palette.primary.main,
        outline: 'none',
        padding: '1rem',
        color: 'white',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: 4,
        boxShadow: '2px 2px .5rem rgba(0, 0, 0, .25)'
    },
    modal: {
        zIndex: theme.zIndex.modal + 300 + ' !important'
    },
    spinner: {
        marginRight: '.5rem',
        color: '#FFCB05 !important'
    }
}));

export default function LoadingModal(props) {
    const {
        handleByRedux = true,
        handleByMessage = false
    } = props;
    const classes = useStyles();
    const [isLoading, setLoading] = useState(false);

    if (!!handleByMessage) {
        useEffect(() => {
            const receiveMessage = event => {
                if (!!event.data && (typeof event.data === 'string' || event.data instanceof String)) {
                    if (event.data.indexOf("showLoading") !== -1) {
                        setLoading(true);
                    } else if (event.data.indexOf("hideLoading") !== -1) {
                        setLoading(false);
                    }
                }
            };

            window.addEventListener('message', receiveMessage, false);

            return () => window.removeEventListener('message', receiveMessage);
        }, []);
    }

    if (!!handleByRedux) {
        const isLoadingBySelector = useSelector(state => state.isLoading);

        useEffect(() => {
            setLoading(isLoadingBySelector);
        }, [isLoadingBySelector]);
    }

    return (
        <Modal open={isLoading} className={classes.modal}>
            <div className={classes.root}>
                <CircularProgress size='1.5rem' className={classes.spinner} />
                <span>Carregando, aguarde...</span>
            </div>
        </Modal>
    );
}

LoadingModal.propTypes = {
    handleByRedux: PropTypes.bool,
    handleByMessage: PropTypes.bool
};